import React from "react";

const TypiconIcons = () => {
  return (
    <div>
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Typicon Icon</h3>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            {/* Chart */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">Typicon Icon</div>
                </div>
                <div className="card-body">
                  <div className="icons-items">
                    <ul className="icons-list">
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-chart-pie-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-chart-pie-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-chart-pie"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-chart-pie"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-chevron-left-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-chevron-left-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-chevron-left"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-chevron-left"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-chevron-right-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-chevron-right-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-chevron-right"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-chevron-right"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-clipboard"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-clipboard"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-cloud-storage"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-cloud-storage"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-cloud-storage-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-cloud-storage-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-code-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-code-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-code"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-code"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-coffee"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-coffee"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-cog-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-cog-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-cog"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-cog"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-compass"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-compass"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-contacts"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-contacts"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-credit-card"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-credit-card"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-css3"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-css3"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-database"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-database"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-delete-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-delete-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-delete"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-delete"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-device-desktop"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-device-desktop"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-device-laptop"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-device-laptop"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-device-phone"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-device-phone"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-device-tablet"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-device-tablet"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-directions"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-directions"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-divide-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-divide-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-divide"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-divide"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-document-add"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-document-add"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-document-delete"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-document-delete"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-document-text"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-document-text"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-document"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-document"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-download-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-download-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-download"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-download"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-dropbox"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-dropbox"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-edit"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-edit"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-eject-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-eject-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-eject"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-eject"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-equals-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-equals-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-equals"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-equals"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-export-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-export-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-export"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-export"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-eye-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-eye-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-eye"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-eye"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-feather"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-feather"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-film"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-film"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-filter"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-filter"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flag-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flag-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flag"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flag"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flash-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flash-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flash"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flash"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flow-children"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flow-children"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flow-merge"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flow-merge"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flow-parallel"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flow-parallel"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-flow-switch"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-flow-switch"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-folder-add"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-folder-add"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-folder-delete"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-folder-delete"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-folder-open"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-folder-open"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-folder"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-folder"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-gift"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-gift"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-globe-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-globe-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-globe"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-globe"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-group-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-group-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-group"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-group"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-headphones"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-headphones"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-heart-full-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-heart-full-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-heart-half-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-heart-half-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-heart-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-heart-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-heart"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-heart"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-home-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-home-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-home"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-home"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-html5"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-html5"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-image-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-image-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-image"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-image"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-infinity-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-infinity-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-info-large-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-info-large-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-info-large"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-info-large"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-info-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-info-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-info"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-info"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-input-checked-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-input-checked-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-input-checked"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-input-checked"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-key-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-key-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-key"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-key"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-keyboard"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-keyboard"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-leaf"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-leaf"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-lightbulb"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-lightbulb"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-link-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-link-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-link"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-link"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-location-arrow-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-location-arrow-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-location-arrow"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-location-arrow"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-location-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-location-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-location"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-location"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-lock-closed-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-lock-closed-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-lock-closed"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-lock-closed"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-lock-open-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-lock-open-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-lock-open"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-lock-open"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-mail"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-mail"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-map"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-map"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-eject-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-eject-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-eject"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-eject"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-fast-forward-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-fast-forward-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-fast-forward"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-fast-forward"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-pause-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-pause-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-pause"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-pause"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-play-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-play-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-play-reverse-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-play-reverse-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-play-reverse"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-play-reverse"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-play"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-play"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-record-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-record-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-record"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-record"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-rewind-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-rewind-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-rewind"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-rewind"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-stop-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-stop-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-media-stop"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-media-stop"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-message-typing"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-message-typing"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-message"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-message"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-messages"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-messages"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-microphone-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-microphone-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-microphone"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-microphone"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-minus-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-minus-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-minus"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-minus"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-mortar-board"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-mortar-board"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-news"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-news"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-notes-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-notes-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-notes"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-notes"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pen"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pen"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pencil"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pencil"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-phone-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-phone-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-phone"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-phone"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pi-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pi-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pi"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pi"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pin-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pin-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pin"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pin"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-pipette"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-pipette"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-plane-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-plane-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-plane"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-plane"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-plug"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-plug"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-plus-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-plus-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-plus"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-plus"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-point-of-interest-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-point-of-interest-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-point-of-interest"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-point-of-interest"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-power-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-power-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-power"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-power"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-printer"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-printer"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-puzzle-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-puzzle-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-puzzle"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-puzzle"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-radar-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-radar-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-radar"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-radar"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-refresh-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-refresh-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-refresh"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-refresh"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-rss-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-rss-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-rss"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-rss"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-scissors-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-scissors-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-scissors"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-scissors"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-shopping-bag"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-shopping-bag"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-shopping-cart"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-shopping-cart"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-at-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-at-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-dribbble-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-dribbble-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-dribbble"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-dribbble"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-facebook-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-facebook-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-facebook"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-facebook"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-flickr-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-flickr-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-flickr"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-flickr"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-github-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-github-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-github"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-github"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-google-plus-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-google-plus-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-google-plus"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-google-plus"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-instagram-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-instagram-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-instagram"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-instagram"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-last-fm-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-last-fm-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-last-fm"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-last-fm"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-linkedin-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-linkedin-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-linkedin"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-linkedin"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-pinterest-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-pinterest-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-pinterest"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-pinterest"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-skype-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-skype-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-skype"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-skype"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-tumbler-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-tumbler-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-tumbler"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-tumbler"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-twitter-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-twitter-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-twitter"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-twitter"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-vimeo-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-vimeo-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-vimeo"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-vimeo"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-youtube-circular"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-youtube-circular"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-social-youtube"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-social-youtube"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-sort-alphabetically-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-sort-alphabetically-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-sort-alphabetically"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-sort-alphabetically"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-sort-numerically-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-sort-numerically-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-sort-numerically"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-sort-numerically"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-spanner-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-spanner-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-spanner"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-spanner"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-spiral"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-spiral"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-star-full-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-star-full-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-star-half-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-star-half-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-star-half"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-star-half"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-star-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-star-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-star"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-star"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-starburst-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-starburst-outline"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-starburst"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-starburst"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-stopwatch"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-stopwatch"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-support"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-support"
                        />
                      </li>
                      <li className="icons-list-item">
                        <i
                          className="typcn typcn-tabs-outline"
                          data-bs-toggle="tooltip"
                          title="typcn typcn-tabs-outline"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* /Chart */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypiconIcons;
